// German IBAN: exactly 22 characters (DE + 2 check digits + 18 digits)
export const ibanRegExp = new RegExp('^(DE\\d{20}|DE\\d{2}( \\d{4}){4} \\d{2})$')
export const plzRegExp = new RegExp('^[0-9]{5}$')
export const phoneRegExp = new RegExp('^\\+?[0-9\\- ]{7,20}$')
